module.exports = __webpack_public_path__ + "static/media/596JamesPBrawleyDrNW_2018-06-12_107.7b402dfe.jpg";